import React, { useEffect, useState } from '../../../_snowpack/pkg/react.js';
import * as Sentry from '../../../_snowpack/pkg/@sentry/browser.js';
import { useTenant } from '../../hooks/index.js';
export const AuthContext = /*#__PURE__*/React.createContext();
export const redirectForAuthenticatedSession = {
  lsKey: 'crystallize:authenticated-redirect',

  save(redirect) {
    try {
      if (redirect) {
        localStorage.setItem(redirectForAuthenticatedSession.lsKey, redirect);
      }
    } catch (e) {}
  },

  get() {
    try {
      return localStorage.getItem(redirectForAuthenticatedSession.lsKey);
    } catch (e) {}
  },

  clear() {
    try {
      localStorage.removeItem(redirectForAuthenticatedSession.lsKey);
    } catch (e) {}
  }

};

function AuthGate(props) {
  const {
    children
  } = props;
  const [checking, setChecking] = useState(true);
  const {
    tenant,
    user
  } = useTenant();
  const [state, setState] = useState({
    view: 'edit'
  });
  useEffect(() => {
    checkStatus();
  });

  const checkStatus = async () => {
    // Attach extra information that we will use for debugging errors
    Sentry.configureScope(scope => {
      if (user) {
        scope.setUser({
          id: user.id,
          email: user.email,
          isAdmin: user.isAdmin,
          firstName: user.firstName,
          lastName: user.lastName
        });
      }

      if (tenant) {
        scope.setExtra('tenant', {
          id: tenant.id,
          identifier: tenant.identifier
        });
      }
    });
    setChecking(false);
  };

  if (checking) {
    return null;
  }

  return /*#__PURE__*/React.createElement(AuthContext.Provider, {
    value: {
      state,
      actions: {
        setState
      }
    }
  }, children);
}

export default AuthGate;